import { Link } from "eddev/routing"
import { BreadcrumbsFragment } from "@generated-types"
import { cn, tv } from "@utils/tw"
import { IconChevronLeft, IconChevronRight } from "@components/ui/Icon"
import { Fragment } from "react/jsx-runtime"

type Props = {
  breadcrumbs?: (BreadcrumbsFragment | null)[] | null | undefined
  className?: string
}

export function Breadcrumbs(props: Props) {
  if (props.breadcrumbs?.length === 0) return null
  return (
    <div className={cn("overflow-auto scrollbars-hidden type-ui-s text-fg", props.className)}>
      <div className="flex items-center gap-2 w-max px-grid-margin-full">
        {props.breadcrumbs?.map((breadcrumb, index) => {
          const item = breadcrumb?.active ? (
            <span className={createStyle()}>{breadcrumb.title}</span>
          ) : (
            <Link
              href={breadcrumb?.uri}
              className={createStyle({ clickable: true, back: !!breadcrumb?.back })}
              // preferBack="exact"
            >
              {breadcrumb?.back && (
                <span className="inline-flex items-center size-[1.8em] -my-3">
                  <IconChevronLeft />
                </span>
              )}
              <span dangerouslySetInnerHTML={{ __html: breadcrumb?.title! }} />
            </Link>
          )
          return (
            <Fragment key={breadcrumb?.title || index}>
              {index !== 0 && <IconChevronRight className="size-[1.3em] text-fg-secondary flex-none" />} {item}
            </Fragment>
          )
        })}
      </div>
    </div>
  )
}

const createStyle = tv({
  base: "flex-none py-5 md:py-4 inline-flex underline underline-offset-[0.2em] decoration-fg/0 transition-colors items-center",
  variants: {
    clickable: {
      true: "hover:text-fg hover:decoration-fg/80 text-fg-secondary",
      false: "text-fg-secondary/60",
    },
    back: {
      true: "-ml-[0.8em]",
      false: "",
    },
  },
})
